import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,

} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { HttpClient } from "@angular/common/http";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
} from "../../../../common/interfaces";
import { environment as env } from "../../../../../environments/environment.prod";
import { StatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { AbstractService } from "../../../../services/abstract.service";
import BadEntityAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/bad-condition/bad-condition.entity";
import { ICreateBadCondition } from "./interfaces/create-bad-condition.interface";
import { IUpdateBadCondition } from "./interfaces/update-bad-condition.interface";


const apiUrl = env.API_UNIT_MEASURE;
const moduleName = "bad_condition";

@Injectable({
  providedIn: "root",
})
export class BadConditionService extends AbstractService<
  BadEntityAttributes,
  ICreateBadCondition,
  IUpdateBadCondition
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCount(
    options: IPagination<BadEntityAttributes>, 
    companyIds: number[] = [],
    statusIds: number[] = []
  ): Observable<IPaginationResult<BadEntityAttributes>> {
  
    const query = buildQuery<BadEntityAttributes>(
      where('_deleted', Ops.eq(false)),
      andWhere("id", Ops.like(options.search ?? "", "i")),
      orWhere("name", Ops.like(options.search ?? "", "i")),
      companyIds && companyIds.length > 0 ? andAllWhere('company.id' as keyof BadEntityAttributes, Ops.in(...companyIds)) : noop(),
      statusIds && statusIds.length > 0 ? andAllWhere('statusId' as keyof BadEntityAttributes, Ops.in(...statusIds)) : noop(),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<BadEntityAttributes>>(API_URL);
  }

  /**
   * Find to combo box
   * @returns Data
   */
  findToComboBox(): Observable<IRequestResult<BadEntityAttributes[]>> {
    const query = buildQuery<BadEntityAttributes>(
      where("statusId", StatusEnum.ACTIVE),
      select(["id", "name"]),
      orderBy("id", OrderVariant.Asc)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<BadEntityAttributes[]>>(API_URL);
  }
}
